import _ from 'underscore';
import { BaseSurvey } from '../base-survey';
import { BudgetCenteOneTimeUserSurveyView } from './view';

const userPrefName = 'BudgetCenterPageLastVisitDate';

export class BudgetCenterOneTimeUserSurvey extends BaseSurvey {
  getSurveyName = () => 'BudgetCenterOneTimeUserSurvey';

  getSurveyId = isTestEnv => (isTestEnv ? '2da1d764-6e4d-4328-9e65-1790deee62b7' : '97e79400-390e-45d3-8a88-d6a1f8e04e41');

  validateTriggerCondition = () => {
    this.logActivity(`validateTriggerCondition | survey: ${this.getSurveyName()}, Start`);
    const isPiloted = _.get(this.serverContext, ['DynamicPermissions', 'SpendSurveyBudgetCenterOneTimeUser'], false);
    const lastVisitDateString = _.get(this.SurveyPreferenceService.PreferenceService.findByNameAtUserLevel(userPrefName), 'Data');
    const isEvaluatorEnabled = _.get(this.serverContext, ['DynamicPermissions', 'BudgetCenterOneTimeUser'], false);
    this.logActivity(`validateTriggerCondition | survey: ${this.getSurveyName()}, isPiloted: ${isPiloted}, lastVisitDateString: ${lastVisitDateString}, isEvaluatorEnabled: ${isEvaluatorEnabled}`);

    if (!isPiloted) {
      this.logActivity(`validateTriggerCondition | survey: ${this.getSurveyName()}, shouldTrigger: false, isPiloted: ${isPiloted}`);
      return false;
    }

    if (!_.isEmpty(lastVisitDateString)) {
      const lastVisitDate = new Date(lastVisitDateString);
      const Days30Ago = this.SurveyPreferenceService.getDaysAgo(30);
      const isUserActiveOneMonth = lastVisitDate >= Days30Ago;
      this.logActivity(`validateTriggerCondition | survey: ${this.getSurveyName()}, shouldTrigger: ${!isUserActiveOneMonth}, lastVisitDateString: ${lastVisitDateString}, isUserActiveOneMonth: ${isUserActiveOneMonth}`);
      return !isUserActiveOneMonth;
    }

    this.logActivity(`validateTriggerCondition | survey: ${this.getSurveyName()}, shouldTrigger: ${isEvaluatorEnabled}, isEvaluatorEnabled: ${isEvaluatorEnabled}`);
    return isEvaluatorEnabled;
  };

  getSurveyComponent = () => BudgetCenteOneTimeUserSurveyView;
}
